export default {
  /** Way to know if user has already seen the guide overlay */
  LS_PAGE_GUIDE_SEEN: 'milva-page-guide-seen-v2',
  /** Way to know if user has already seen the feedback overlay */
  LS_FEEDBACK_SEEN: 'milva-feedback-seen-v1',
}
